export enum IndicatorIcon {
    FAST_FORWARD = 'fas fa-fast-forward',
    INBOX = 'fas fa-inbox',
    CALENDAR = 'fas fa-calendar-alt',
    CHECK = 'fas fa-check',
    TIMES = 'fas fa-times',
    MINUS = 'fas fa-minus',
    ASTERISK = 'fas fa-asterisk',
    USER = 'fas fa-user',
    POINT = 'fas fa-hand-point-up',
    MESSAGE = 'fas fa-envelope',
    CREATED = 'fas fa-plus-circle',
    NONE = ''
}
